export const useButtonTheme = () => {
    const buttonTheme = (theme) => {
        switch (theme) {
            case 'solid':
            default:
                return 'brand'
            case 'text':
                return 'text-link'
            case 'outline':
                return 'outline'
        }
    }

    return {
        buttonTheme,
    }
}
